import type {
  PolicyContent,
  UnacceptedPolicies,
  UnacceptedPolicy,
} from '@/types/policy';
import type {
  PolicyContentWire,
  UnacceptedPoliciesResponseWire,
  UnacceptedPolicyWire,
} from '../schemas/policy';

/**
 * Convert an unaccepted policy from wire format to domain format.
 * Maps snake_case to camelCase and the ISO effective_date to Unix milliseconds.
 */
export function mapUnacceptedPolicy(wire: UnacceptedPolicyWire): UnacceptedPolicy {
  return {
    policyId: wire.policy_id,
    policyType: wire.policy_type,
    versionId: wire.version_id,
    versionNumber: wire.version_number,
    effectiveDate: new Date(wire.effective_date).getTime(),
    contentR2Key: wire.content_r2_key,
    changeSummary: wire.change_summary,
  };
}

/**
 * Convert the unaccepted-policies response from wire format to domain format.
 */
export function mapUnacceptedPolicies(
  wire: UnacceptedPoliciesResponseWire
): UnacceptedPolicies {
  return {
    policies: wire.policies.map(mapUnacceptedPolicy),
    isFirstAcceptance: wire.is_first_acceptance,
  };
}

/**
 * Convert policy content from wire format to domain format.
 */
export function mapPolicyContent(wire: PolicyContentWire): PolicyContent {
  return {
    content: wire.content,
    contentHash: wire.content_hash,
  };
}
